import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import DownloadFile from "../../services/DownloadFile";

// import Loader from '../../../components/ui/Loader/Loader';
// import DateService from '../../../services/DateService';
// import HttpAPICall from '../../../services/HttpAPICall';
// import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
// import TapIcon from '../../../services/TapIcon';
// import DataService from '../../../services/DataService';
// import TapHelper from '../../../services/TapHelper';
// import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
// import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import api from '../../services/api';
import { IAM_COUNTERLOG_URL } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';

const ProductivityBulkAddModal                  =   forwardRef((props, ref) => {


    
    const accessToken                       =   useSelector(state => state.auth.access_token);


    let initFormData                        =   {
        loading                                 :   false,
        submitting                              :   false,
    };

    const [formData, setFormData]           =   useState({...initFormData});
    const [searchModalId, setSearchModalId] =   useState(uuid());
    const searchModalElem                   =   useRef(null);
    const searchModal                       =   useRef(null);
    const searchModalOpen                   =   ()  => searchModal.current && searchModal.current.show()
    const searchModalClose                  =   ()  => searchModal.current && searchModal.current.hide()
    useEffect(() => {
        searchModalElem.current             =   document.getElementById(searchModalId);
        searchModal.current                 =   new Modal(searchModalElem.current, {keyboard: false, backdrop :false});
        //Cleanup on unmount
        return () => {
            searchModal.current && searchModal.current.dispose();
        };
    }, []);

    const sampleFileApiUrl                  =   IAM_COUNTERLOG_URL + '/productivity_sample_excel';
    const bulkAddProductivityApiUrl         =   IAM_COUNTERLOG_URL + '/productivity_bulk_add';


    useImperativeHandle(ref, () => ({
        initModalHandler: ()    =>  searchModalOpenHandler(),
        initModalClose: ()      =>  editModalCloseHandler()
    }));

    const searchModalOpenHandler            =   ()  =>  {
       searchModalOpen();
       setFormData(pd => ({...initFormData}));
    }

    const editModalCloseHandler             =   ()  =>  {
        searchModalClose();
    }

    const downloadSampleFile                =   (e)  =>  {
        setFormData(pd => ({...pd, loading : true}));
        api.server2Api.get(sampleFileApiUrl, {headers : { 'Authorization': 'Bearer ' + accessToken}}).then((response) => {
            DownloadFile.file(response.data.file_path);
            editModalCloseHandler();
            toast.success('File Downloaded Successfully', { position: toast.POSITION.TOP_RIGHT });
        }).catch((error) => {}).then(() => {
            setFormData(pd => ({...pd, loading : false}));
        });
    }

    const submitSearchFormHandler          =   (e)  =>  {
        e.preventDefault();
        setFormData(pd => ({...pd, submitting : true}));
        const data = new FormData(document.getElementById(searchModalId + 'Form'));
        api.server2Api.post(bulkAddProductivityApiUrl, data, { headers: { 'Authorization': 'Bearer ' + accessToken } })
        .then((response) => {
            toast.success(response.data.message, { position: toast.POSITION.TOP_RIGHT });
            editModalCloseHandler();
            if(response.data.generated_file && response.data.generated_file.file_path){
                DownloadFile.file(response.data.generated_file.file_path);
            }
        }).catch((err) => {}).then(() => {
            setFormData(pd => ({...pd, submitting : false}));
        });
    }

    let disabled            =   formData.loading || formData.submitting;
    
    return <>
          <div className="modal fade" id={searchModalId} tabIndex="-1" ref={searchModalElem}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Bulk Add Productivity</h5>
                        <button disabled={disabled} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form id={searchModalId + 'Form'} onSubmit={submitSearchFormHandler} method="post" encType="multipart/form-data">
                            <div className="row align-items-center mb-3 mt-3">
                                <div className="col-12">
                                    <input name="document" type="file" className="form-control" required={true} />
                                </div>
                                <div className="col-12 mt-2 form-text"># Excel Sheet with Extention xls,xlm,xlsx,ods Allowed</div>
                                <div className="col-12 mt-2 form-text"># Miximum 50 MB Size of Excel Sheet Allowed</div>
                                <div className="col-12 mt-2 form-text"># Miximum 500 Productivity Rows are Allowed</div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer d-flex justify-content-between">
                        <div>
                            <Link type="button" disabled={disabled} className={['float-left', disabled ? 'disabled-link' : '' ].join(" ")} onClick={downloadSampleFile}>Download Sample File</Link>
                        </div>
                        <div>
                            <button disabled={disabled} type="button" className="btn btn-secondary mx-2" data-bs-dismiss="modal">Close</button>
                            <button disabled={disabled} form={searchModalId + 'Form'} type="submit" className="btn btn-primary">Submit {formData.submitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </>
});

export default ProductivityBulkAddModal;